export default "__VITE_ASSET__su$smE7l__"